const c = {
  name: "Hands00100",
  dimensions: { width: 26, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 26 40" style="enable-background:new 0 0 26 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M14,12.5c0.6-0.3,1.3-0.5,2-0.5c1.7,0,3.2,1.1,3.8,2.7c0.6-0.4,1.4-0.7,2.2-0.7c2.2,0,4,1.8,4,4v9
			c0,7.2-5.8,13-13,13S0,34.2,0,27V17c0-2.2,1.8-4,4-4c0.7,0,1.4,0.2,2,0.5V4c0-2.2,1.8-4,4-4s4,1.8,4,4V12.5z M10,2
			C8.9,2,8,2.9,8,4v15h2c0.7,0,1.4,0.2,2,0.5V4C12,2.9,11.1,2,10,2z M14,16v7c0,1.1,0.9,2,2,2c1.1,0,2-0.9,2-2v-7c0-1.1-0.9-2-2-2
			C14.9,14,14,14.9,14,16z M19.8,24.3c-0.5,1.6-2,2.7-3.8,2.7c-1.2,0-2.3-0.5-3-1.4c-0.7,0.8-1.8,1.4-3,1.4H6v-2h4c1.1,0,2-0.9,2-2
			s-0.9-2-2-2H4c-1.1,0-2,0.9-2,2v4c0,6.1,4.9,11,11,11c6.1,0,11-4.9,11-11v-2.5c-0.6,0.3-1.3,0.5-2,0.5
			C21.2,25,20.4,24.8,19.8,24.3z M20,18v3c0,1.1,0.9,2,2,2c1.1,0,2-0.9,2-2v-3c0-1.1-0.9-2-2-2C20.9,16,20,16.9,20,18z M6,17
			c0-1.1-0.9-2-2-2c-1.1,0-2,0.9-2,2v2.5C2.6,19.2,3.3,19,4,19h2V17z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Hands00100
};
